














import { Component, Vue, Watch } from "vue-property-decorator";
import { gameInfo } from "@/req/homes";
import topBanner from "./components/topBanner.vue";
import gameBanner from "./components/gameBanner.vue";
import detailInfo from "./components/detailInfo.vue";
import detailInfoBox from "./components/detailInfoBox.vue";

@Component({
  components: { topBanner, gameBanner, detailInfo, detailInfoBox },
})
export default class Home extends Vue {
  public bannerShow = false;
  public detail: any = {};
  public gameId: any = "";
  public mounted() {
    this.gameId = this.$route.query.id;
    this.getList();
  }
  public async getList() {
    const obj = {
      box_game_id: this.gameId,
    };
    const res = await gameInfo(obj);
    if (res.code == 200) {
      if (res.data.game_info.publicity.length == 0) {
        this.bannerShow = false;
      } else {
        this.bannerShow = true;
      }
      this.detail = res.data.game_info;
    }
  }
  @Watch("$route.query.id")
  public change() {
    this.gameId = this.$route.query.id;
    this.getList();
  }
}
